import * as Colors from '../../constants/Colors';
import { SvgIconProps } from '../IconProps';
import { BaseSvgIcon } from '../BaseSvgIcon';

export type WorldIconProps = SvgIconProps & {
    color?: string;
};

export const WorldIcon = ({ color, ...props }: WorldIconProps) => (
    <BaseSvgIcon viewBox="0 0 25 24" fill="none" {...props}>
        <circle cx="12" cy="12.1719" r="9" stroke={color} strokeWidth="2" />
        <path
            d="M15 12.1719C15 14.8386 14.5658 17.2069 13.9 18.8716C13.5659 19.7066 13.1932 20.3153 12.8304 20.6989C12.4697 21.0804 12.1887 21.1719 12 21.1719C11.8113 21.1719 11.5303 21.0804 11.1696 20.6989C10.8068 20.3153 10.4341 19.7066 10.1 18.8716C9.43419 17.2069 9 14.8386 9 12.1719C9 9.5051 9.43419 7.13684 10.1 5.4722C10.4341 4.6371 10.8068 4.0284 11.1696 3.64483C11.5303 3.26337 11.8113 3.17188 12 3.17188C12.1887 3.17188 12.4697 3.26337 12.8304 3.64483C13.1932 4.0284 13.5659 4.6371 13.9 5.4722C14.5658 7.13684 15 9.5051 15 12.1719Z"
            stroke={color}
            strokeWidth="2"
        />
        <path d="M3 9.17188H20" stroke={color} strokeWidth="2" />
        <path d="M3 15.1719H20" stroke={color} strokeWidth="2" />
    </BaseSvgIcon>
);

WorldIcon.defaultProps = {
    color: Colors.black,
    height: '24px',
    width: '24px',
};
